import { render, staticRenderFns } from "./UndoIconButton.vue?vue&type=template&id=05cc5004"
import script from "./UndoIconButton.vue?vue&type=script&lang=js"
export * from "./UndoIconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports